// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__TTPk6","footer":"Footer_footer__6pPV-","text":"Footer_text__GENzN","footerItems":"Footer_footerItems__qb6gB","link":"Footer_link__vxtFx"};